<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="mx-auto col-lg-12 col-12">
        <div class="mt-4 card card-body">
          <Form 
          titlePage="Edit SSMARTBOT Pricing"
          subtitlePage="Edit a SSMARTBOT Pricing"
          submitButtonName="Update Pricing"
          :onSubmit="onSubmit"
          :recordProps="record" />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "./Form.vue";
import PricingsService from "@/services/pricings.service.js";
import { ref } from 'vue';
import { toast } from 'vue3-toastify';

const toastId = ref('');


export default {
  name: "InternalUserEdit",
  components: {
    Form
  },

  data() {
    return {
      record: {},
    };
  },
  mounted(){
    this.getRecord()
  },
  methods: {
    showLoading(){
      toastId.value = toast.loading('Please wait...');
    },
    hideLoading(){
      setTimeout(() => {
        toast.remove(toastId.value)
      }, 1000); 
    },
    showSuccess(){
      toast.update(toastId.value, {
        render: "Update Successfully",
        closeOnClick: true,
        closeButton: true,
        type: 'success',
        isLoading: false,
        autoClose: 3000
      });
      
      setTimeout(() => {
        this.$router.replace('/pricings/smart-trade')
      }, 1000);     
    },
    showFailed(e){
      toast.update(toastId.value, {
        render: e,
        closeOnClick: true,
        closeButton: true,
        type: 'error',
        isLoading: false,
        autoClose: 3000
      });
    },
    getRecord(){
      this.showLoading()

      PricingsService.get(this.$route.params.id).then(e => {
        this.record = e.data.pricing_data
        // this.record.pricing_models = this.record.pricing_models.slice(0, 1)
        this.hideLoading()
      }).catch(e => {
        this.showFailed(e.response.data.code_message)           
      });
    },
    onSubmit(data){
      this.showLoading()

      data.product_type = 'smart-trade'
      PricingsService.update(data, this.$route.params.id).then(() => {
        this.showSuccess()
      }).catch(e => {
        this.showFailed(e.response.data.code_message)           
      });

    }
  }
};
</script>
